import React from "react";
import { Skeleton } from "@/components/ui/skeleton";

const ProductCardSkeleton: React.FC = () => {
  return (
    <div
      className="md:w-full md:my-8 md:rounded-lg 
                md:shadow-[0_0_15px_rgba(0,0,0,0.2)] md:h-60 md:px-12 md:py-10"
    >
      <div
        className="w-full h-[7rem] my-2 border-b-2 border-grayCloud flex text-left
                    md:border-0 md:h-full md:my-0 justify-between"
      >
        <div className="w-[64%] h-full flex flex-col justify-between pb-5">
          {/* Product name skeleton */}
          <Skeleton className="h-4 w-32" />

          {/* Product description skeleton */}
          <Skeleton className="h-3 w-[90%]" />
          <Skeleton className="h-3 w-[80%]" />

          {/* Price skeleton */}
          <Skeleton className="h-4 w-20 mt-2" />
        </div>

        {/* Product image skeleton */}
        <div className="md:flex md:h-full md:items-center md:justify-center">
          <Skeleton className="w-24 h-24 rounded-lg md:w-36 md:h-36" />
        </div>
      </div>
    </div>
  );
};

export default ProductCardSkeleton;
